import {createFeatureSelector, createSelector} from '@ngrx/store';
import {PlayerState} from './player.reducer';
import {Player} from 'gamesis-story-client';

export const selectPlayerState = createFeatureSelector<PlayerState>('players');

export const selectPlayers = createSelector(
    selectPlayerState,
    (state: PlayerState) => state.players
);

export const selectPlayersLoading = createSelector(
    selectPlayerState,
    (state: PlayerState) => state.loading
);

export const selectMe = createSelector(
    selectPlayerState,
    (state: PlayerState) => state.me
);

export const selectPlayerCount = createSelector(
    selectPlayerState,
    (state: PlayerState) => state.players.length
);

export const selectOtherPlayers = createSelector(
    selectPlayers,
    selectMe,
    (players: Player[], me: Player) => players.filter(player => player.id !== me?.id)
);

export const selectInvites = createSelector(
    selectPlayerState,
    (state: PlayerState) => state.invites
);

export const isGameMaster = createSelector(
    selectPlayerState,
    (state: PlayerState) => state.me?.gameMaster
);

export const selectPlayerById = (id: string) => createSelector(
    selectPlayers,
    (players: Player[]) => players.find(player => player.id === id)
);


